import { LegalLayout, H2, Todo, LEGAL } from "@/components/LegalLayout";
import { openCookieSettings } from "@/lib/consent";

const Row = ({ name, purpose, type, duration }) => (
  <tr className="border-t border-dashed border-[#D1D5CB]">
    <td className="py-2 pr-3 font-mono text-xs">{name}</td>
    <td className="py-2 pr-3">{purpose}</td>
    <td className="py-2 pr-3">{type}</td>
    <td className="py-2">{duration}</td>
  </tr>
);

export default function Confidentialite() {
  return (
    <LegalLayout eyebrow="Tes données, en toute douceur" title="Confidentialité & cookies" testId="confidentialite-page">
      <section>
        <H2>Qui est responsable ?</H2>
        <p className="mt-2">Le responsable du traitement est <strong>{LEGAL.name}</strong> ({LEGAL.status.toLowerCase()}, SIRET {LEGAL.siret}). Contact : <Todo>{LEGAL.email}</Todo> — ou en répondant à l'un de nos e-mails.</p>
      </section>

      <section>
        <H2>Quelles données collectons-nous, et pourquoi ?</H2>
        <ul className="mt-2 list-disc pl-5 space-y-1.5">
          <li><strong>Commandes</strong> : nom, adresse de livraison, e-mail et détail des articles, transmis par Stripe lors du paiement. Base légale : exécution du contrat. Conservation : 10 ans pour les pièces comptables.</li>
          <li><strong>E-mails de commande</strong> (confirmation, expédition) envoyés à l'adresse indiquée lors du paiement. Base légale : exécution du contrat.</li>
          <li><strong>Newsletter « les potes qui papotent »</strong> : adresse e-mail, uniquement si tu t'inscris. Base légale : consentement. Désinscription possible à tout moment en nous écrivant. Conservation : jusqu'à désinscription ou 3 ans d'inactivité.</li>
          <li><strong>Avis « mots doux »</strong> : prénom, note et message que tu choisis de publier. Base légale : consentement. Tu peux en demander la modification ou la suppression.</li>
          <li><strong>Suivi de commande</strong> : la page « Où est mon colis ? » n'affiche que le statut, le transporteur et la ville de destination, jamais ton adresse complète ni ton e-mail.</li>
        </ul>
        <p className="mt-2">Nous ne vendons ni ne louons jamais tes données. Elles ne sont partagées qu'avec nos prestataires indispensables : <strong>Stripe</strong> (paiement), notre service d'envoi d'e-mails transactionnels, et le transporteur choisi pour la livraison.</p>
      </section>

      <section>
        <H2>Paiement</H2>
        <p className="mt-2">Le paiement est entièrement réalisé sur les pages sécurisées de Stripe. Nous ne voyons ni ne stockons jamais ton numéro de carte. Stripe peut déposer ses propres cookies sur ses pages, nécessaires à la sécurité et à la lutte contre la fraude.</p>
      </section>

      <section>
        <H2>Cookies et données locales</H2>
        <p className="mt-2">MiniMellow n'utilise <strong>aucun cookie publicitaire ni traceur tiers</strong>. Voici la liste exhaustive de ce que ton navigateur conserve :</p>
        <div className="mt-3 overflow-x-auto rounded-2xl border-2 border-dashed border-[#D1D5CB] bg-[#FAF9F6] p-3">
          <table className="w-full text-left text-xs sm:text-sm" data-testid="cookie-table">
            <thead><tr className="text-[#78353A]"><th className="pb-2 pr-3">Nom</th><th className="pb-2 pr-3">Finalité</th><th className="pb-2 pr-3">Catégorie</th><th className="pb-2">Durée</th></tr></thead>
            <tbody>
              <Row name="mm_cart" purpose="Mémoriser le contenu de ton panier" type="Essentiel (stockage local)" duration="Jusqu'à vidage du panier" />
              <Row name="mm_cookie_consent" purpose="Mémoriser ton choix concernant les cookies" type="Essentiel (stockage local)" duration="6 mois" />
              <Row name="mm_promo_banner_closed" purpose="Ne pas réafficher le bandeau promo que tu as fermé" type="Essentiel (stockage local)" duration="Jusqu'à effacement" />
              <Row name="mm_admin_secret" purpose="Session de l'espace privé (réservé à l'équipe)" type="Essentiel (session)" duration="Fermeture du navigateur" />
              <Row name="Mesure d'audience" purpose="Statistiques anonymes de visite" type="Optionnel — soumis à ton accord" duration="Aucun outil installé à ce jour" />
            </tbody>
          </table>
        </div>
        <p className="mt-3">Tu peux modifier ton choix à tout moment : <button type="button" onClick={openCookieSettings} className="text-[#78353A] underline decoration-dotted underline-offset-4" data-testid="privacy-cookie-settings">gérer mes cookies</button>.</p>
      </section>

      <section>
        <H2>Tes droits</H2>
        <p className="mt-2">Conformément au RGPD et à la loi Informatique et Libertés, tu disposes d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de tes données, ainsi que du droit de retirer ton consentement à tout moment. Pour l'exercer, écris-nous à <Todo>{LEGAL.email}</Todo>. Tu peux aussi introduire une réclamation auprès de la CNIL (cnil.fr).</p>
      </section>
    </LegalLayout>
  );
}
